



















import { isString } from 'lodash-es';
import { computed, defineComponent, reactive, ref } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { GenericObjectType } from '~/utils/types';

export default defineComponent({
    componentName: "PBAccordion",
    props: {
        node: {
            type: Object as PropType<GenericObjectType>,
            required: true
        }
    },
    setup(props) {
        const { node: content } = props as Readonly<{ [key: string]: any }>;
        const selectedIndexes = ref<number[]>([]);
        const paddingClasses = ref([])
        const allOpened = content.cssClasses.includes('opened')
        const exclusiveOpening = !content.children.some(child => child.cssClasses.includes('opened')) && !allOpened;
        allOpened ? selectedIndexes.value = new Array(content.children.length).fill(0).map((_, i) => i)
            : content.children.forEach((child, index) => {
                if (child.cssClasses.includes('opened')) {
                    selectedIndexes.value.push(index);
                }
            })

        if (content.cssClasses.includes('autori-block') && content.children.length == 1) {
            selectedIndexes.value = [0];
        } else {
            paddingClasses.value = ['px-3', 'md:px-5']

        }
        return {
            content,
            selectedIndexes,
            paddingClasses,
            exclusiveOpening,
            hasFaqs: content.cssClasses?.includes('seo-faq')
        };
    },
    head() {
        let faqScript: { hid: string; type: string; json: any } | null = null;
        const content = this.content as GenericObjectType;
        const hasFaqs = content.cssClasses?.includes('seo-faq');
        if (hasFaqs) {
            const faqs = content.children.map(el => {
                return {
                    "@type": "Question",
                    "name": el.title,
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": el.content?.textContent
                    }
                }
            })
            faqScript = {
                hid: 'ld-faq',
                type: 'application/ld+json',
                json: {
                    "@context": "https://schema.org/",
                    "@type": "FAQPage",
                    "mainEntity": faqs
                }
            }
        }
        return {
            script: faqScript ? [faqScript] : []
        }
    },
    computed: {
    },
    methods: {
        toggleAccordion(index) {
            if (this.exclusiveOpening) {
                this.selectedIndexes.includes(index) ? this.selectedIndexes = [] : this.selectedIndexes = [index];
                return;
            }
            this.selectedIndexes.includes(index)
                ? this.selectedIndexes = this.selectedIndexes.filter(el => el != index)
                : this.selectedIndexes.push(index)
        },

        keyDown(e, index) {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                this.toggleAccordion(index);
            }
        },
        renderHTML(content) {
            if (process.server) {
                //@ts-ignore
                return isString(content) ? content : content.outerHTML;
            }

            //@ts-ignore
            return content;
        }
    }
})
